// extracted by mini-css-extract-plugin
module.exports = {"chacas_odonto_center__redText":"ChacasOdontoCenter_chacas_odonto_center__redText__Qv931","chacas_odonto_center__image":"ChacasOdontoCenter_chacas_odonto_center__image__3bxN4"};